import { AddressWithCopy, Token } from '@/components/molecules'
import { DeleteIcon, SettingsIcon, ViewIcon } from '@chakra-ui/icons'
import {
  Circle,
  HStack,
  IconButton,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tooltip,
  Tr,
} from '@chakra-ui/react'
import { Link as ReactRouterLink, useNavigate } from 'react-router-dom'
import { useAccount } from 'wagmi'

export const SubscriptionsTable = ({ subscriptions = [], submitCancelSub }) => {
  const navigate = useNavigate()
  const { chain } = useAccount()
  const blockExplorerUrl = chain?.blockExplorers?.default?.url

  const handleSubClick = (subId) => {
    navigate(`${subId}`)
  }

  return (
    <TableContainer overflow={'auto'} zIndex={0}>
      <Table overflow={'auto'} size={['sm', 'md']}>
        <Thead>
          <Tr>
            <Th>ID</Th>
            <Th>Admin address</Th>
            <Th>Consumers</Th>
            <Th>Balance</Th>
            <Th textAlign={'center'}>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {subscriptions.map(
            ({ formattedBalance, owner, subId, consumersCount }) => (
              <Tr key={subId}>
                <Td>
                  <HStack>
                    <Circle
                      size={'16px'}
                      bg={'green.400'}
                      boxShadow={'0 0 0 1px LightGray'}
                      border={'3px solid'}
                      borderColor={'primary.50'}
                    />
                    <Tooltip label="View subscription" placement={'bottom'}>
                      <Link
                        onClick={() => handleSubClick(subId)}
                        fontSize={'large'}
                        color={'primary.500'}
                        _hover={{
                          color: 'primary.600',
                          textDecoration: 'underline',
                        }}
                      >
                        {subId}
                      </Link>
                    </Tooltip>
                  </HStack>
                </Td>
                <Td>
                  <AddressWithCopy
                    to={`${blockExplorerUrl}/address/${owner}`}
                    address={owner}
                    symbols={5}
                  />
                </Td>
                <Td>{consumersCount}</Td>
                <Td>
                  <Token
                    amount={formattedBalance}
                    decimal={4}
                    toFtn={false}
                    symbol={'FTN'}
                  />
                </Td>
                <Td textAlign={'center'}>
                  <Menu>
                    <MenuButton
                      variant={'outline'}
                      _hover={{ bg: 'primary.100' }}
                      as={IconButton}
                      icon={<SettingsIcon />}
                    />
                    <Portal>
                      <MenuList zIndex={1}>
                        <MenuItem
                          iconSpacing={2}
                          icon={<ViewIcon />}
                          as={ReactRouterLink}
                          to={`/subscriptions/${subId}`}
                        >
                          View Subscription
                        </MenuItem>
                        <MenuItem
                          onClick={() => submitCancelSub({ subId })}
                          iconSpacing={2}
                          icon={<DeleteIcon />}
                          color={'red'}
                        >
                          Cancel Subscription
                        </MenuItem>
                      </MenuList>
                    </Portal>
                  </Menu>
                </Td>
              </Tr>
            ),
          )}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
